/* ============================================
   Custom BOGOS JS
   Strip currency code prefix "A$" → "$" trong widget BOGOS
   (BOGOS render giá bằng Intl currency format có country code,
    không tôn trọng shop.money_format → cần can thiệp JS)
   ============================================ */
(function () {
  'use strict';

  // CUSTOM: Bỏ qua hoàn toàn trong Theme Editor.
  // Trong editor, Shopify mutate DOM liên tục (overlay chọn section, re-render khi
  // đổi settings...). MutationObserver quan sát toàn document.body với subtree +
  // characterData sẽ fire điên loạn → stripAll quét lại toàn cây DOM mỗi lần →
  // nghẽn main thread → editor "load mãi". Storefront thật không bị (DOM tĩnh).
  if (window.Shopify && window.Shopify.designMode) return;

  // ============================================
  // PHẦN 1 — Strip "A$" -> "$" ĐÃ TẮT (comment) theo yêu cầu.
  // Bật lại: bỏ cặp dấu comment block bao quanh khối bên dưới.
  // Phần 2 (Cart Count Sync) bên dưới VẪN HOẠT ĐỘNG bình thường.
  // ============================================
  /*
  // Match bất cứ element BOGOS nào có class chứa "price"
  var PRICE_SELECTOR = '[class*="bogos-"][class*="price"]';
  var STRIP_REGEX = /A\$/g;

  function stripIn(el) {
    if (!el || el.nodeType !== 1) return;
    if (!el.textContent || el.textContent.indexOf('A$') === -1) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf('A$') !== -1) {
        node.nodeValue = node.nodeValue.replace(STRIP_REGEX, '$');
      }
    }
  }

  function stripAll(root) {
    if (!root) return;
    if (root.matches && root.matches(PRICE_SELECTOR)) stripIn(root);
    if (!root.querySelectorAll) return;
    var els = root.querySelectorAll(PRICE_SELECTOR);
    for (var i = 0; i < els.length; i++) stripIn(els[i]);
  }

  function init() {
    stripAll(document);

    // CHỈ nghe node mới được thêm (childList), KHÔNG nghe characterData.
    // App BOGOS (thanh tiến trình quà tặng) cập nhật text liên tục → nếu observer nghe
    // characterData trên toàn body, nó fire vô tận → stripAll quét lại toàn DOM mỗi lần
    // → main thread khóa cứng, treo trang sau ~5s.
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          stripAll(nodes[j]);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  */

  /* ============================================
     BOGOS Cart Count Sync
     BOGOS sau khi add bundle KHÔNG cập nhật cart count icon ở header.
     → Fetch /cart.js → update badge count thủ công.
     Không re-dispatch cart:update để tránh trigger lại logic drawer của theme
     (BOGOS đã tự handle drawer rồi → double trigger gây trắng trang).
     ============================================ */
  var COUNT_SELECTOR = '.custom-cart-count, .hdt-header-cart-count, .hdt-navbar-mobile__count';
  var BOGOS_ADD_BUTTON_SELECTOR = '.bogos-bundles-button-add, .bogos-fbt-footer-button-add';

  function updateCartCountBadges(itemCount) {
    document.querySelectorAll(COUNT_SELECTOR).forEach(function (el) {
      el.textContent = itemCount;
      if (itemCount > 0) el.classList.add('is-visible');
    });
  }

  function readBadgeCount() {
    var el = document.querySelector(COUNT_SELECTOR);
    if (!el) return 0;
    var n = parseInt((el.textContent || '').trim(), 10);
    return isNaN(n) ? 0 : n;
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); } catch (e) { console.error('BOGOS drawer open error:', e); }
    }
  }

  function freezeBadges() {
    // Snapshot trạng thái hiện tại (gọi ngay khi click, trước khi BOGOS clear)
    var els = document.querySelectorAll(COUNT_SELECTOR);
    var snapshots = [];
    els.forEach(function (el) {
      snapshots.push({
        el: el,
        text: el.textContent,
        wasVisible: el.classList.contains('is-visible')
      });
    });

    function restore() {
      snapshots.forEach(function (s) {
        if (s.el.textContent !== s.text) s.el.textContent = s.text;
        if (s.wasVisible && !s.el.classList.contains('is-visible')) {
          s.el.classList.add('is-visible');
        }
      });
    }

    // Restore liên tục bằng MutationObserver
    var observer = new MutationObserver(restore);
    els.forEach(function (el) {
      observer.observe(el, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });

    // Fallback: restore mỗi 50ms trong tối đa 5s (phòng case element bị replace mất observer)
    var intervalId = setInterval(restore, 50);
    var safetyTimeout = setTimeout(function () {
      clearInterval(intervalId);
      observer.disconnect();
    }, 5000);

    return function release() {
      clearInterval(intervalId);
      clearTimeout(safetyTimeout);
      observer.disconnect();
    };
  }

  function syncCartCount(release) {
    return fetch(Shopify.routes.root + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (release) release();
        updateCartCountBadges(cart.item_count);
        return cart;
      })
      .catch(function (err) {
        if (release) release();
        console.error('BOGOS cart count sync error:', err);
        return null;
      });
  }

  /* ============================================
     BOGOS Drawer Content Refresh
     BOGOS dispatch cart:update KHÔNG kèm cartData.sections → theme không render lại
     được nội dung drawer (count đúng nhưng list rỗng). Kích hoạt event `cart:reload`
     có sẵn của theme: CartDrawer sẽ FETCH section từ server (cart lúc này đã có items)
     rồi dispatch cart:update với data hợp lệ → drawer render đúng.
     Dùng cart:reload (server fetch) thay vì re-dispatch cart:update với data BOGOS
     → tránh trắng trang do cartData thiếu sections.
     Lưu ý: KHÔNG dùng cart:tab vì HdtCartCount ở header đọc event.detail.item_count
     từ cart:tab → detail rỗng sẽ set badge thành "undefined". cart:reload thì không.
     ============================================ */
  function refreshDrawerContent() {
    document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true, detail: {} }));
  }

  // Bắt click trên BOGOS add button ở capture phase — chạy TRƯỚC BOGOS handler
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest(BOGOS_ADD_BUTTON_SELECTOR);
    if (!btn) return;
    var oldCount = readBadgeCount();
    var release = freezeBadges();
    // Đợi BOGOS xử lý xong rồi fetch cart mới — chờ cart:update event hoặc fallback 2.5s
    var done = false;
    function handleUpdate() {
      if (done) return;
      done = true;
      document.removeEventListener('cart:update', handleUpdate);
      // Chỉ mở drawer khi BOGO add thành công (item_count thực sự tăng).
      // Nếu BOGO fail/timeout → count không đổi → không mở để tránh confuse user.
      syncCartCount(release).then(function (cart) {
        refreshDrawerContent();
        if (cart && typeof cart.item_count === 'number' && cart.item_count > oldCount) {
          openCartDrawer();
        }
      });
    }
    document.addEventListener('cart:update', handleUpdate);
    setTimeout(handleUpdate, 2500);
  }, true);
})();
